import { ISystemConfigsCollection } from '../definitions/Common'
import { IFormField } from '../definitions/FormField'
import { ISystemConfig } from '../definitions/MiscSchema'

export class EditorOptionsRegistryClass {
    private groups: ISystemConfigsCollection[] = []

    setOptions(collections: ISystemConfigsCollection[]) {
        this.groups = Array.isArray(collections) ? collections : []
    }

    getOptionsForField(field: IFormField): ISystemConfig[] {
        if (!field.systemConfigType && !field.stringOptionsType) return []

        const targetKey = field.systemConfigType || field.stringOptionsType!

        const group = this.groups.find(g =>
            g.uuid === targetKey || g.name === targetKey
        )

        return group?.values || []
    }

    resolveValue(field: IFormField, rawValue: any): ISystemConfig | null {
        const options = this.getOptionsForField(field)
        if (options.length === 0) return null

        const str = String(rawValue).trim().toLowerCase()
        return (
            options.find(o => o.uuid === rawValue) || options.find(o => o.name && o.name.toLowerCase() === str) || null
        )
    }

    getAllGroups() {
        return this.groups
    }
}

const editorOptionsRegistry = new EditorOptionsRegistryClass()
export default editorOptionsRegistry
